export const ACTIVE_RUN_STATUSES = new Set(['created', 'pending', 'dispatching', 'queued', 'running']);
export const TERMINAL_RUN_STATUSES = new Set(['completed', 'failed', 'cancelled', 'abandoned']);

export function isRunActive(run) {
  return ACTIVE_RUN_STATUSES.has(String(run?.status || '').toLowerCase());
}

export function isRunTerminal(run) {
  return TERMINAL_RUN_STATUSES.has(String(run?.status || '').toLowerCase());
}

export function formatRunDuration(seconds) {
  const value = Number(seconds);
  if (!Number.isFinite(value) || value < 0) {
    return 'N/A';
  }
  if (value < 60) {
    return `${Math.round(value)}s`;
  }
  if (value < 3600) {
    return `${Math.floor(value / 60)}m ${Math.round(value % 60)}s`;
  }
  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value % 3600) / 60);
  return `${hours}h ${minutes}m`;
}

export function runContextLabel(run) {
  const context = run?.capability_request || run?.shared_with?.capability_request;
  if (!context) {
    return '-';
  }
  return context.capability_name || context.request_title || context.capability_request_id || '-';
}

export function runStatusColor(status) {
  const value = String(status || '').toLowerCase();
  if (value === 'completed') return 'success';
  if (['failed', 'failed_to_dispatch', 'cancelled'].includes(value)) return 'error';
  if (['running', 'queued', 'pending', 'dispatching', 'abandoned'].includes(value)) return 'warning';
  return 'default';
}
